import React from "react";
import Badge from "../images/badge.svg";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const Footer = () => {
  const navigateToTerms = () => {
    window.open("/terms", "_blank");
  };
  const navigateToPrivacyPolicy = () => {
    window.open("/privacy-policy", "_blank");
  };

  return (
    <div className="bg-slate-100">
      <div className="hidden md:grid px-7 py-5 grid sm:grid-cols-12 grid-cols-1 items-center text-gray-500">
        <div className="md:col-span-4 text-sm text-center sm:text-left mb-2 sm:mb-0 flex items-center justify-center sm:justify-start gap-2">
          <span>
            © {new Date().getFullYear()} Tipkit LLC. All Rights Reserved.
          </span>
          <a
            href="https://www.linkedin.com/company/tipkit"
            target="_blank"
            rel="noopener noreferrer"
          >
            <LinkedInIcon sx={{ fontSize: "35px", color: "#2867B2" }} />
          </a>
        </div>

        <div className="md:col-span-4 flex justify-center mb-2 sm:mb-0">
          <img src={Badge} style={{ width: "180px" }} alt="Badge" />
        </div>
        <div className="md:col-span-4 flex flex-col sm:flex-row justify-center sm:justify-end text-center sm:text-right space-y-2 sm:space-y-0 sm:space-x-4">
          <a
            onClick={navigateToPrivacyPolicy}
            className="text-sm hover:text-primary hover:cursor-pointer"
          >
            Privacy Policy
          </a>
          <a
            onClick={navigateToTerms}
            className="text-sm hover:text-primary hover:cursor-pointer"
          >
            Terms of Use
          </a>
          <a
            className="text-sm hover:text-primary hover:cursor-pointer"
            href="mailto:hello@tipkit.co"
          >
            Support
          </a>
        </div>
      </div>

      {/* Mobile View */}
      <div className="md:hidden flex flex-col p-4 text-gray-500">
        <div className="flex justify-between items-start w-full">
          <img
            src={Badge}
            style={{ width: "170px" }}
            alt="Badge"
            className="flex-shrink-0"
          />

          <div className="flex flex-col items-end space-y-1 pr-2">
            <a
              onClick={navigateToPrivacyPolicy}
              className="text-sm hover:text-primary hover:cursor-pointer text-right"
            >
              Privacy Policy
            </a>
            <a
              onClick={navigateToTerms}
              className="text-sm hover:text-primary hover:cursor-pointer text-right"
            >
              Terms of Use
            </a>
            <a
              className="text-sm hover:text-primary hover:cursor-pointer text-right"
              href="mailto:hello@tipkit.co"
            >
              Support
            </a>
          </div>
        </div>

        <div className="border-t border-gray-300 mt-3 w-full"></div>

        <div className="flex items-center justify-center space-x-1 mt-3">
          <span className="text-xs sm:text-sm">
            © {new Date().getFullYear()}  Tipkit LLC. All Rights Reserved.
          </span>
          <a
            href="https://www.linkedin.com/company/tipkit"
            target="_blank"
            rel="noopener noreferrer"
          >
            <LinkedInIcon fontSize="small" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
